import fp from '@auxo.dev/fp'
import CSS from 'csstype'
import React from 'react'
import { Factory } from './factory'

declare namespace Slot {

  interface Props extends React.Props<any> {
    as?: any
    className?: string
    style?: CSS.Properties
    components?: React.ReactChildren
    slot: 'Actions' | 'Meta' | string
  }

}

const getScope = function(children, scope) {
  const normChildren = React.Children.toArray(children)
  const splitted = fp.filter(child => {
    return (child as any).props?.slot === scope
  }, normChildren)
  // const newChildren = fp.remove(child => child.props?.role?.name === scope, normChildren)
  return splitted
}

function Slot({ slot, children, components, ...rest }: Slot.Props) {
  return (
    <Factory {...rest}>
      {components && getScope(components, slot)}
      {children}
    </Factory>
  )
}

export {
  Slot
}